import React from 'react';
import { Link } from 'react-router-dom';

// import '../assets/css/style.css';

// import Header from "../components/Partials/Header";
// import Footer from '../components/Partials/Footer';

// import useSlideUpAnimation from '../hooks/Animations/useSlideUpAnimation';
// import useTextAnimation from '../hooks/Animations/useTextAnimation';

// import vector1 from "../assets/img/et-3-event-vector.svg";
// import vector2 from "../assets/img/breadcrumb-bg.jpg";

function NotFound() {
    // useSlideUpAnimation();
    // useTextAnimation();

    return (
        <>
            <main>

                <div className="py-[60px] md:py-[30px] xl:py-[40px] text-center">
                    <div className="mx-auto px-[12px] max-w-[calc(100%-37.1vw)] lg:max-w-full xl:max-w-[calc(100%-170px)] xxxl:max-w-[calc(100%-350px)] container">
                        <section class="error-container">
                            <span class="four"><span class="screen-reader-text">4</span></span>
                            <span class="zero"><span class="screen-reader-text">0</span></span>
                            <span class="four"><span class="screen-reader-text">4</span></span>
                        </section>
                        <h2 className="mb-[3px] font-medium text-[60px] xxs:text-[35px] sm:text-[40px] md:text-[45px] lg:text-[50px] anim-text">
                            <span className="text-orange-600">Oups !</span> Page introuvable
                        </h2>
                        <Link
                            to="/"
                            className="inline-flex justify-center items-center gap-[10px] bg-orange-600 hover:bg-orange-500 mt-2 px-[24px] rounded-[10px] h-[56px] font-medium text-[16px] text-white transition-all duration-300"
                        >
                            Retourner à l'accueil <i className="fa-arrow-right-long fa-solid"></i>
                        </Link>
                    </div>
                </div>
            </main>
        </>
    );
}

export default NotFound;